import PropTypes from "prop-types";
import Base from "./base";

const FreeText = PropTypes.shape({
  ...Base,
  displayLocalizedLabel: PropTypes.bool,
});

export default FreeText;
